import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import suitcss from '../../../helpers/suitcss';

function ButtonToggleIcons(props) {
  if (!props.onClick) {
    return null;
  }
  return (
    <button
      onClick={props.onClick}
      className={suitcss({
        componentName: 'ButtonToggleIcons',
        states: [props.icon],
      })}
      aria-expanded={props.icon === 'burger' ? 'false' : 'true'}
      aria-controls="mobile-main-menu"
      aria-label={props.icon === 'burger' ? props.ui.guiNavBurgerOpen : props.ui.guiNavBurgerClose}
    >
      <span
        className={suitcss({
          componentName: 'ButtonToggleIcons',
          descendantName: 'line',
        })}
      />
      <span
        className={suitcss({
          componentName: 'ButtonToggleIcons',
          descendantName: 'line',
        })}
      />
      <span
        className={suitcss({
          componentName: 'ButtonToggleIcons',
          descendantName: 'line',
        })}
      />
    </button>
  );
}

const mapStateToProps = (state) => ({
  ui: state.ui,
});

ButtonToggleIcons.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.oneOf(['burger', 'cross']),
};
ButtonToggleIcons.defaultProps = {
  icon: 'burger',
};

export default compose(
  connect(mapStateToProps),
)(ButtonToggleIcons);
